import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { faBars, faCaretDown, faCaretUp, faLanguage, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';

import { Language, Languages } from '@app/core/models';
import { User } from '@app/core/domain';
import { ExternalLinksService, MobileAppService, PropertiesService } from '@app/core/services';

@Component({
  selector: 'ingo-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  animations: [
    trigger('mobileNavState', [
      state('open', style({
        display: 'block',
        transform: 'translate3d(0, 0, 0)'
      })),
      state('closed', style({
        display: 'none',
        transform: 'translate3d(0, -100%, 0)'
      })),
      transition('closed => open', animate('250ms ease-in')),
      transition('open => closed', animate('200ms ease-out'))
    ])
  ]
})
export class NavbarComponent implements OnInit {

  @Input() accessBlocked: boolean;
  @Input() user: User;
  @Input() currentLanguage: Language;
  @Input() currentRoute: Array<string> = [];
  @Output() onSelectLanguage: EventEmitter<Language> = new EventEmitter();
  @Output() onLogout: EventEmitter<void> = new EventEmitter();

  // icons
  faLanguage = faLanguage;
  faQuestionCircle = faQuestionCircle;
  faBars = faBars;
  faTimes = faTimes;
  faCaretDown = faCaretDown;
  faCaretUp = faCaretUp;

  languages = Languages;
  mobileNavState: string = 'closed';
  mobileLangSelectCollapsed: boolean = true;
  faqUrl: string = '';

  constructor(
    private properties: PropertiesService,
    private externalLinks: ExternalLinksService,
    private mobileAppService: MobileAppService
  ) { }

  ngOnInit(): void {
    this.faqUrl = this.externalLinks.getFaqUrl();
  }

  isIos(): boolean {
    return this.mobileAppService.isIos();
  }

  toggleMobileNav(): void {
    if (this.mobileNavState === 'open') {
      this.closeMobileNav();
    } else {
      this.openMobileNav();
    }
  }

  closeMobileNav(): void {
    this.mobileNavState = 'closed';
    this.mobileLangSelectCollapsed = true;
  }

  openMobileNav(): void {
    this.mobileNavState = 'open';
  }

  toggleMobileLangSelect(): void {
    this.mobileLangSelectCollapsed = !this.mobileLangSelectCollapsed;
  }

  selectLanguage(language: Language) {
    this.onSelectLanguage.emit(language);
    this.closeMobileNav();
  }

  logOut(): void {
    this.onLogout.emit();
  }

  invoicesVisible(): boolean {
    return this.user.containsPlcCard && !this.properties.isFeatureDisabled('INVOICES_MODULE');
  }

  goToFaq(): void {
    window.open(this.faqUrl);
  }
}
